import React from 'react';

class SortableColumn extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      name: this.props.name,
      order: this.props.order
    };
  }

  onSortClick () {
    this.props.onSortChange(this.state.name, this.state.order);

    let order = this.state.order === 'desc' ? 'asc' : 'desc';
    this.setState({order});
  }

  renderOrderIndicator () {
    if (this.state.order === 'desc') {
      return <i className='sort-icon rc-icon-caret-down'></i>
    }
    else {
      return <i className='sort-icon rc-icon-caret-up'></i>
    }
  }

  render () {
    return (
      <span
        className='sortable-column'
        onClick={this.onSortClick.bind(this)}>
        {this.props.children || this.props.label || this.state.name}
        {this.renderOrderIndicator()}
      </span>
    )
  }
}

SortableColumn.defaultProps = {
  name: '',
  order: 'desc',
  onSortChange: () => {}
}

export default SortableColumn;



/** WEBPACK FOOTER **
 ** ./modules/shared/crud_list_sortable_column.js
 **/